export default __webpack_public_path__ + "static/media/image-grid.043c26ef.jpg";